module.exports = __webpack_public_path__ + "img/img_hy.dbbfb789.png";